<p-card styleClass="flex w-full h-full p-4" class="h-full">
  <ng-template pTemplate="header">
    <h2>Overdue Payments (Consulted By Me)</h2>
  </ng-template>
  <div class="nano-content">
    <div *ngIf="loading" class="text-center m-t">
      <p>Loading overdue payments...</p>
    </div>

    <div *ngIf="error" class="text-center m-t text-danger">
      <p>{{ error }}</p>
    </div>

    <div *ngIf="!loading && !error && getTotalDue() > 0" class="m-l m-r m-t m-b">
      <div>
        <span style="font-size: 18px; font-weight: 100; line-height: 1.1;" class="no-margins">Payments Paid</span>
        &nbsp;
        <span class="stat-percent pull-right" style="line-height:1.1; font-size:18px; font-weight:100;">{{ getPaymentPercentage() | number:'1.1-1' }}%</span>
        <br>
        <span class="small"><span style="font-weight: 600;">Goal:</span> 100%</span>
        <span class="stat-percent pull-right small" style="line-height:1.1;">(${{ getTotalPaid() | number:'1.2-2' }}/${{ getTotalDue() | number:'1.2-2' }})</span>
      </div>

      <div class="progress progress-mini">
        <div [style.width.%]="getPaymentPercentage()" 
             [class.progress-bar-my-registrations]="getPaymentPercentage() < 100"
             class="progress-bar"></div>
      </div>
    </div>

    <div *ngIf="!loading && !error && !hasOverduePayments()" class="text-center m-l m-r m-t">
      <hr *ngIf="getTotalDue() > 0">
      <p>All your past due payments are paid... nice!</p>
    </div>

    <div *ngIf="!loading && !error && hasOverduePayments()">
      <p-table 
        [value]="overduePayments()" 
        [scrollable]="true" 
        styleClass="p-datatable-sm flex flex-col w-full"
        [rows]="5"
        [paginator]="true">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns()">
              <app-table-header [column]="col"></app-table-header>
            </th>
            <th class="text-right">Remaining</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-payment>
          <tr>
            <td *ngFor="let col of columns()">
              <app-table-column *ngIf="col.field !== 'chargeTypeID'" [column]="col" [data]="payment"></app-table-column>
              <div *ngIf="col.field === 'chargeTypeID'">
                {{ getChargeTypeName(payment.chargeTypeId) }}
              </div>
            </td>
            <td class="text-right">{{ getRemainingAmount(payment) | currency }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card> 